'use client'

import Link from 'next/link'
import s from './AwardedComponent.module.scss'
import { useEffect, useMemo, useRef, useState } from 'react'
import { motion, AnimatePresence } from 'framer-motion'
import FeaturedProduct from '../../Singles/FeaturedProduct'
import LazyImage from '@/components/Common/LazyImage'
import { PortableText } from 'next-sanity'
import { portableBlockComponents } from '@/utils/portableText'
import { set } from 'sanity'
import SelectedWorkBlock from '@/components/Common/SelectedWorkBlock'

type Work = {
    slug: string
    title: string
    client?: { title?: string }
    author?: string
    categories?: Array<{ title?: string }>
    year?: number | string
    featuredImage?: { imageUrl: string; filename?: string; alt?: string; metadata?: { dimensions?: { width?: number; height?: number } } }
    info?: any[]
    projectLink?: string
    projectLinkText?: string
    inWorkList?: boolean
    pinterestLink?: string
    featuredImageList?: any[]
    awards?: Array<{ year: string; name: string }>
}

type SelectedBlock = { title?: string; contentLeft?: any[]; contentRight?: any[] } | null
type Props = { data: Work[]; selectedBlock?: SelectedBlock }

export default function AwardedComponent({ data, selectedBlock }: Props) {


    return (
        <>
        <div className={s.productsAwarded}>
            {data.map((product, index) => (
                <div key={`award-${index}`} className={s.productAwarded}>
                    <div className={s.imageLabel}>
                        {product.featuredImage && (
                            <LazyImage
                                src={product.featuredImage.imageUrl}
                                alt={product.featuredImage.filename || ''}
                                width={product.featuredImage.metadata?.dimensions?.width || 800}
                                height={product.featuredImage.metadata?.dimensions?.height || 600}
                            />
                        )}
                    </div>
                    
                    <div className={s.info}>
                        <h2>{product.title} {product.client?.title && <>{`× ${product.client.title}`}</>}</h2>
                        {product.author && <p>{product.author}</p>}
                        {product.year && <p>{product.year}</p>}
                        <div className={s.link}>
                            {product.inWorkList ? <p><Link href={`/work/${product.slug}`}>↗ View project</Link></p> :
                            product.pinterestLink ? <p><Link href={product.pinterestLink} target={'_blank'} rel="noopener noreferrer nofollow">↗ View on Pinterest</Link></p> :
                            product.projectLink ? <p><Link href={product.projectLink} target={'_blank'} rel="noopener noreferrer">↗ {product.projectLinkText || "Link to website"}</Link></p> : null}
                        </div>
                    </div>
  
                    <div className={s.awards}>
                        {product.awards && product.awards.map((award, awardIndex) => (
                            <div key={awardIndex} className={s.award}>
                                <p translate='no'>{award.name}</p>
                                <p className={s.awardYear}>{award.year}</p>
                            </div>
                        ))}
                    </div>
                        {/* <div className={s.awardsYears}>
                            {product.awards && product.awards.map((award, awardIndex) => (
                                <div key={awardIndex} className={s.awardYear}>
                                    <p>{award.year}</p>
                                </div>
                            ))}
                        </div> */}

                </div>
            ))}
        </div>
        <SelectedWorkBlock data={selectedBlock} />
        </>
    )
}